import { SYSTEM_ERROR } from "../config/CONSTANTS";
import {
  ACCOUNT_DETAILS,
  ACCOUNT_DETAILS_UPDATE,
  CHATBOT_BETA_ENROLL,
  GET_USER_STATUS,
  GET_STORE_PRODUCTS_VARIANT_COUNT,
  GET_SHOP_VARIANT_LIMIT,
  GET_ONBOARDING_USER_STEPS_PROGRESS,
  GET_CURRENT_BILLING_PLAN_STATUS,
  GET_STORE_DETAILS,
} from "./CONSTANTS";
import axiosInstance from "../utils/axiosInstance";

export const getAccountDetails = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(ACCOUNT_DETAILS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getAccountDetials Axios!");
        });
    } catch (error) {
      console.error(
        "in billingPlanServices > getAccountDetails, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateUserDetails = (userUpdateObj) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .put(ACCOUNT_DETAILS_UPDATE(), userUpdateObj)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in Updating user information Axios!");
        });
    } catch (error) {
      console.error("in userServices > updateUserDetails, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

export const getUserStatus = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_USER_STATUS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in Updating user information Axios!");
        });
    } catch (error) {
      console.error("in userServices > getUserStatus, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

export const getStoreProductVariantCount = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_STORE_PRODUCTS_VARIANT_COUNT())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in Updating user information Axios!");
        });
    } catch (error) {
      console.error("in userServices > getUserStatus, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

export const getShopVariantLimit = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_SHOP_VARIANT_LIMIT())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getShopVariantLimit Axios!");
        });
    } catch (error) {
      console.error("in userServices > getShopVariantLimit, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOnboardingUserStepsProgress = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_ONBOARDING_USER_STEPS_PROGRESS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in Updating user information Axios!");
        });
    } catch (error) {
      console.error("in userServices > getUserStatus, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAccountAndBillingDetails = () => {
  return new Promise((resolve, reject) => {
    let userDetails;
    let billingPlanDetails;

    try {
      axiosInstance
        .get(ACCOUNT_DETAILS())
        .then((response) => {
          userDetails = response.data;
          // Make second request using data from the first request
          return axiosInstance.get(GET_CURRENT_BILLING_PLAN_STATUS());
        })
        .then((response) => {
          billingPlanDetails = response.data;

          resolve({
            userDetails: userDetails,
            billingPlanDetails: billingPlanDetails,
          });
        })
        .catch((error) => {
          //When billing status call is made in init app before plan selection it fails.
          //when call fails return null and continue intercom and inspeclet resgistration when store and user details.
          resolve({
            userDetails: userDetails,
            billingPlanDetails: null,
          });
        });
    } catch (error) {
      console.error(
        "in billingPlanServices > getAccountDetails, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

export const getStoreDetails = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_STORE_DETAILS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          const data = {
            data: [],
            error: [],
            message: "",
            pageRecordCount: 0,
            success: false,
            totalResultsCount: 0,
          };
          reject(data);
        });
    } catch (error) {
      console.error("in userServices > getStoreDetails, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

export const getStoreDetailsAndBillingDetails = () => {
  return new Promise((resolve, reject) => {
    let storeDetails;
    let billingPlanDetails;

    try {
      axiosInstance
        .get(GET_STORE_DETAILS())
        .then((response) => {
          storeDetails = response.data;
          // Make second request using data from the first request
          return axiosInstance.get(GET_CURRENT_BILLING_PLAN_STATUS());
        })
        .then((response) => {
          billingPlanDetails = response.data;

          resolve({
            storeDetails: storeDetails,
            billingPlanDetails: billingPlanDetails,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error(
        "in billingPlanServices > getAccountDetails, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

/**
 * Grails APIs often wrap payloads as { data: { ... } }.
 * Example: axios res.data → { data: { showChatbot: true } }
 */
function unwrapApiPayload(body) {
  if (
    body &&
    typeof body === "object" &&
    body.data != null &&
    typeof body.data === "object" &&
    !Array.isArray(body.data)
  ) {
    return body.data;
  }

  return body ?? {};
}

/**
 * Enrolls the logged-in shop in the chatbot beta program.
 * 200: { enrolled, slotsRemaining, showBanner, showChatbot }
 * 409: { error: "SLOTS_FULL", ... }
 */
export const enrollChatbotBeta = () => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(CHATBOT_BETA_ENROLL())
      .then((res) => {
        resolve(unwrapApiPayload(res.data));
      })
      .catch((err) => {
        const status = err?.response?.status;
        const data = err?.response?.data ?? {};

        if (status === 409) {
          reject({
            code: data.error || "SLOTS_FULL",
            ...data,
          });
          return;
        }

        reject(err);
      });
  });
};
